import { render, staticRenderFns } from "./IdentityClient.vue?vue&type=template&id=557ad8f6&scoped=true&"
import script from "./IdentityClient.vue?vue&type=script&lang=js&"
export * from "./IdentityClient.vue?vue&type=script&lang=js&"
import style0 from "./IdentityClient.vue?vue&type=style&index=0&id=557ad8f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557ad8f6",
  null
  
)

export default component.exports